import { render, staticRenderFns } from "./BasicServiceManage.vue?vue&type=template&id=c5665ce6"
import script from "./BasicServiceManage.vue?vue&type=script&lang=js"
export * from "./BasicServiceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports